import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import TotalDisplay from './TotalDisplay';
import DateTimeDisplay from '../../../components/booking/DateTimeDisplay';
import DurationPill from '../../../components/booking/DurationPill';

export default function StepReview({
  selectedLocation, selectedDate, selectedTimeSlot, duration,
  courtsRequested, courtsPricing, specialRequests,
  loading, getConsecutiveSlots,
  onBack, onSubmit,
}) {
  return (
    <div className="space-y-6 animate-slide-up" data-testid="step-review">
      <div>
        <h2 className="text-xl font-bold font-heading uppercase mb-4">Review Booking</h2>

        <Card className="p-6 mb-4 bba-card bba-card-accent">
          <div className="space-y-3">
            <div>
              <p className="text-xs uppercase font-bold text-muted-foreground">Location</p>
              <p className="font-bold">{selectedLocation?.name}</p>
              <p className="text-sm text-muted-foreground">{selectedLocation?.address}</p>
            </div>
            <div>
              <p className="text-xs uppercase font-bold text-muted-foreground">Date & Time</p>
              <DateTimeDisplay
                date={selectedDate}
                timeSlot={selectedTimeSlot}
                duration={duration}
                className="mt-1"
                testId="step-review"
              />
              <div className="mt-3">
                <DurationPill
                  duration={duration}
                  timeSlot={selectedTimeSlot}
                  variant="prominent"
                  hideForOneHour={false}
                  testId="step-review"
                />
              </div>
              {duration > 1 && (
                <div className="mt-3 space-y-0.5">
                  <p className="text-xs uppercase font-bold text-muted-foreground">Includes</p>
                  {getConsecutiveSlots(selectedTimeSlot, duration).map((slot, idx) => (
                    <p key={slot} className="text-sm text-muted-foreground">
                      {idx === 0 ? '▸ ' : '  '}{slot}
                    </p>
                  ))}
                </div>
              )}
            </div>
            <div>
              <p className="text-xs uppercase font-bold text-muted-foreground">
                Courts ({courtsRequested.length})
              </p>
              {courtsRequested.map((court, idx) => {
                const pricing = courtsPricing[idx];
                return (
                  <div key={court._uid || `court-summary-${idx}`} className="flex justify-between items-center">
                    <p className="font-bold capitalize">{court.sport}</p>
                    {pricing && (
                      <p className="text-sm text-muted-foreground">
                        BND {pricing.price_per_hour}/hr × {duration}hr = BND {pricing.total}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
            {specialRequests && (
              <div>
                <p className="text-xs uppercase font-bold text-muted-foreground">Special Requests</p>
                <p className="text-sm">{specialRequests}</p>
              </div>
            )}
          </div>
        </Card>

        <Card className="p-6 bba-card bba-card-accent border-orange-400 bg-orange-50/40">
          <div className="flex justify-between items-center">
            <p className="text-lg font-bold uppercase">Estimated Total</p>
            <TotalDisplay courtsPricing={courtsPricing} />
          </div>
        </Card>

        <p
          className="text-xs text-muted-foreground my-4 leading-relaxed"
          data-testid="no-refund-policy-notice"
        >
          <span className="font-bold">No Refund Policy:</span> All payments are final. No-show
          bookings may be eligible for rescheduling, subject to approval and availability.{' '}
          <span className="font-bold">Terms &amp; Conditions</span> apply.
        </p>
      </div>

      <div className="flex gap-3">
        <Button
          variant="outline"
          onClick={onBack}
          data-testid="review-back-button"
          className="flex-1 h-14 rounded-full"
        >
          Back
        </Button>
        <Button
          onClick={onSubmit}
          data-testid="submit-booking-button"
          className="flex-1 btn-primary h-14"
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Pay Now'}
        </Button>
      </div>
    </div>
  );
}
